<template>
  <div>
    <v-dialog v-model="openModal">
      <v-card>
        <v-card-title>Nuevo paciente</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field label="Nombre" v-model="form.name" />
            </v-col>
            <v-col>
              <v-text-field label="Altura" v-model="form.height" :rules="rules" />
            </v-col>
            <v-col>
              <v-text-field label="Fecha de nacimiento" type="date" v-model="form.birthday" />
            </v-col>
            <v-col>
              <v-select label="Género" v-model="form.gender" :items="['Hombre', 'Mujer']" />
            </v-col>
            <v-col>
              <v-text-field label="Ocupación" v-model="form.occupation" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red" dark @click="closeModal">Cerrar</v-btn>
          <v-btn color="success" @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["openModal"],
  data() {
    return {
      form: {},
      modalStatus: this.openModal,
      rules: [
        value => {
          const pattern = /^\d{1}.\d{2}$/;
          return pattern.test(value) || "Altura inválida";
        }
      ]
    };
  },
  methods: {
    save() {
      this.openLoader();
      const peticion = this.sendRequest(
        `${this.$store.state.apiUrl}catalogs/patients`,
        this.form,
        "POST"
      );

      peticion
        .then(({ message }) => {
          this.showSuccessMessage(message);
          this.closeModal();
        })
        .finally(this.closeLoader);
    },
    closeModal() {
      this.modalStatus = false;
      this.$emit("close-modal");
    },
  },
};
</script>